import { Country } from '.';

const euCountryCodes: Country[] = [
  'AD',
  'AL',
  'BA',
  'BG',
  'BY',
  'EE',
  'GR',
  'HR',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MD',
  'MK',
  'MT',
  'RO',
  'RU',
  'SI',
  // 'SJ',
  'SK',
  'SM',
  'TR',
  'UA',
  // 'VA',
  // 'YU',
];

const gbCountryCodes = ['UK', 'FO', 'GG', 'GI', 'IM', 'JE'];

// Map EU and UK countries to the correct country code
export const mapCountryCodes = (countryCode: Country) => {
  if (euCountryCodes.includes(countryCode)) return 'EU';
  if (gbCountryCodes.includes(countryCode)) return 'GB';

  return countryCode;
};
